<script setup>
import { useProductsStore } from '@/stores/products'; // Import Pinia store
import ProductList from "@/components/ProductList.vue";

const productsStore = useProductsStore();

</script> 

<template>
  <div>
    <product-list class="list"
                  :products-data="productsStore.productsData"
                  :products="productsStore.products">

    </product-list>
  </div> <!-- Pass products to ProductList -->
</template>

<style scoped>

</style>